import type { ModuleEntityItem } from "ee/pages/PackageIDE/types";
import { jsCollectionIdURL } from "ee/RouteBuilder";

export const getJSEntityItemUrl = (item: ModuleEntityItem): string => {
  return jsCollectionIdURL({
    baseCollectionId: item.key,
    baseModuleId: item.moduleId,
  });
};
